<template>
  <div class="fw-medium fs-20">Выберите размер</div>
  <!-- eslint-disable -->
  <div class="mt-4">
    Узнайте о наличии товара в салонах в
    <span data-href="/local/components/orteka/city.selector/ajax.php" class="btn color-tertiary hover-color-dark js-popup-link">
      <span class="mr-8 js-city-current">г. {{ currentCity }},</span>
    </span>выбрав нужный размер
  </div>
  <!-- eslint-enable -->

  <div class="mt-24">
    <Sizes :availability="true" />
  </div>

  <div class="mt-20">
    <Params :availability="true" />
  </div>

  <div class="mt-20">
    <Availability v-if="active" :mapId="mapId" />
  </div>
</template>

<script>
import Availability from "@/pages/product_card/components/Availability/Availability.vue";
import Params from "@/pages/product_card/components/Properties/PropertiesBlock.vue";
import Sizes from "@/pages/product_card/components/Properties/Sizes.vue";

export default {
  name: "AvailabilityMain",
  components: {
    Sizes,
    Params,
    Availability,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    mapId: {
      type: String,
      default: "availability-yandex-map",
    },
  },
  data() {
    return {
      activeEl: 1,
      currentCity: window.dataApp.delivery.current_city,
    };
  },
};
</script>

<style lang="scss">
@import "./availability.scss";
</style>
